import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import DataTable from 'react-data-table-component';
import { api } from '../api';

function Communities() {
  const [communities, setCommunities] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    api.getCommunities().then(data => {
      setCommunities(data);
      setLoading(false);
    });
  }, []);
  const [deleteId, setDeleteId] = useState(null);
  const columns = [
    { name: 'ID', selector: row => row.id, sortable: true },
    { name: 'Name', selector: row => row.name, sortable: true },
    { name: 'Icon', cell: row => <img src={row.icon} alt={row.name} style={{ width: 32, height: 32 }} />, ignoreRowClick: true },
    { name: 'Created At', selector: row => new Date(row.createdAt).toLocaleString(), sortable: true },
    { name: 'Updated At', selector: row => new Date(row.updatedAt).toLocaleString(), sortable: true },
    { name: 'Action', cell: row => (
      <div className="dropdown">
        <button className="btn btn-outline-secondary dropdown-toggle" type="button" id={`actionDropdown-com-${row.id}`} data-bs-toggle="dropdown" aria-expanded="false">
          Actions
        </button>
        <ul className="dropdown-menu" aria-labelledby={`actionDropdown-com-${row.id}`}>
          <li><button className="dropdown-item" onClick={() => openEditModal(row)}>Edit</button></li>
          <li><button className="dropdown-item text-danger" onClick={() => setDeleteId(row.id)}>Delete</button></li>
        </ul>
      </div>
    ), ignoreRowClick: true, allowOverflow: true, button: true },
  ];
  const [formData, setFormData] = useState({ id: '', name: '', icon: '' });
  const [editForm, setEditForm] = useState({ id: '', name: '', icon: '' });
  const [updateLoading, setUpdateLoading] = useState(false);
  const [updateError, setUpdateError] = useState('');
  const [addLoading, setAddLoading] = useState(false);
  const [addError, setAddError] = useState('');
  // ...existing code...

  function handleInputChange(e) { const { name, value } = e.target; setFormData(prev => ({ ...prev, [name]: value })); }
  function handleEditInputChange(e) { const { name, value } = e.target; setEditForm(prev => ({ ...prev, [name]: value })); }
  function resetForm() { setFormData({ id: '', name: '', icon: '' }); }
  async function handleAdd(e) {
    e.preventDefault();
    setAddError('');
    setAddLoading(true);
    if (!formData.name) { setAddLoading(false); return; }
    const payload = { name: formData.name, icon: formData.icon };
    try {
      const created = await api.createCommunity(payload);
      if (created) {
        setLoading(true);
        const data = await api.getCommunities();
        setCommunities(data);
        setLoading(false);
        resetForm();
        try { const el = document.getElementById('addCommunity'); if (el && window.bootstrap) (window.bootstrap.Modal.getInstance(el) || new window.bootstrap.Modal(el)).hide(); } catch {}
      } else {
        setAddError(created?.message || 'Failed to add community.');
      }
    } catch (err) {
      setAddError(err?.message || 'An error occurred while adding.');
    } finally {
      setAddLoading(false);
    }
  }
  function openEditModal(c) { setEditForm({ id: c.id, name: c.name, icon: c.icon }); try { const el = document.getElementById('editCommunity'); if (el && window.bootstrap) (window.bootstrap.Modal.getInstance(el) || new window.bootstrap.Modal(el)).show(); } catch {} }
  async function handleUpdate(e) {
    e.preventDefault();
    setUpdateError('');
    setUpdateLoading(true);
    if (!editForm.id) { setUpdateLoading(false); return; }
    const payload = { name: editForm.name, icon: editForm.icon };
    try {
      const updated = await api.updateCommunity(editForm.id, payload);
      if (updated) {
        setLoading(true);
        const data = await api.getCommunities();
        setCommunities(data);
        setLoading(false);
        try { const el = document.getElementById('editCommunity'); if (el && window.bootstrap) (window.bootstrap.Modal.getInstance(el) || new window.bootstrap.Modal(el)).hide(); } catch {}
      } else {
        setUpdateError(updated?.message || 'Failed to update community.');
      }
    } catch (err) {
      setUpdateError(err?.message || 'An error occurred while updating.');
    } finally {
      setUpdateLoading(false);
    }
  }
  async function handleDelete(id) {
    await api.deleteCommunity(id);
    setLoading(true);
    const data = await api.getCommunities();
    setCommunities(data);
    setLoading(false);
    setDeleteId(null);
  }
  {/* Delete Confirmation Modal */}
  <div className={deleteId ? "modal fade show" : "modal fade"} id="deleteCommunityModal" tabIndex="-1" aria-labelledby="deleteCommunityModalLabel" aria-hidden={!deleteId} style={deleteId ? { display: 'block', background: 'rgba(0,0,0,0.5)' } : {}}>
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header px-4">
          <h5 className="modal-title" id="deleteCommunityModalLabel">Confirm Delete</h5>
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => setDeleteId(null)}></button>
        </div>
        <div className="modal-body px-4">
          <p>Are you sure you want to delete this community? This action cannot be undone.</p>
        </div>
        <div className="modal-footer px-4">
          <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => setDeleteId(null)}>Cancel</button>
          <button type="button" className="btn btn-danger" onClick={() => handleDelete(deleteId)}>Delete</button>
        </div>
      </div>
    </div>
  </div>

  return (
    <>
      <Helmet><title>Communities | Owena Admin Dashboard</title></Helmet>
      <div className="ec-content-wrapper">
        <div className="content">
          <div className="breadcrumb-wrapper breadcrumb-contacts">
            <div>
              <h1>Communities</h1>
              <p className="breadcrumbs"><span><a href="#" onClick={(e)=>e.preventDefault()}>Home</a></span><span><i className="mdi mdi-chevron-right"></i></span>Communities</p>
            </div>
            <div>
              <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#addCommunity">Add Community</button>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="ec-vendor-list card card-default">
                <div className="card-body">
                  <DataTable
                    columns={columns}
                    data={communities}
                    progressPending={loading}
                    pagination
                    highlightOnHover
                    pointerOnHover
                    responsive
                    noDataComponent={<div className="text-center">No communities found.</div>}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Add Community Modal */}
          <div className="modal fade" id="addCommunity" tabIndex="-1" aria-labelledby="addCommunityLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered"><div className="modal-content">
              <div className="modal-header px-4"><h5 className="modal-title" id="addCommunityLabel">Add Community</h5><button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div>
              <div className="modal-body px-4">
                <form onSubmit={handleAdd}>
                  <div className="mb-3"><label className="form-label" htmlFor="com-name">Name</label><input id="com-name" name="name" className="form-control" value={formData.name} onChange={handleInputChange} required /></div>
                  <div className="mb-3"><label className="form-label" htmlFor="com-icon">Icon URL</label><input id="com-icon" name="icon" className="form-control" value={formData.icon} onChange={handleInputChange} /></div>
                  {addError && <div className="alert alert-danger py-2 mb-2">{addError}</div>}
                  <div className="d-flex justify-content-end gap-2">
                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="submit" className="btn btn-primary" disabled={addLoading}>
                      {addLoading ? <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> : null}
                      {addLoading ? 'Saving...' : 'Add'}
                    </button>
                  </div>
                </form>
              </div>
            </div></div>
          </div>

          {/* Edit Community Modal */}
          <div className="modal fade" id="editCommunity" tabIndex="-1" aria-labelledby="editCommunityLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered"><div className="modal-content">
              <div className="modal-header px-4"><h5 className="modal-title" id="editCommunityLabel">Edit Community</h5><button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div>
              <div className="modal-body px-4">
                <form onSubmit={handleUpdate}>
                  <div className="mb-3"><label className="form-label" htmlFor="edit-com-name">Name</label><input id="edit-com-name" name="name" className="form-control" value={editForm.name} onChange={handleEditInputChange} required /></div>
                  <div className="mb-3"><label className="form-label" htmlFor="edit-com-icon">Icon URL</label><input id="edit-com-icon" name="icon" className="form-control" value={editForm.icon} onChange={handleEditInputChange} /></div>
                  {updateError && <div className="alert alert-danger py-2 mb-2">{updateError}</div>}
                  <div className="d-flex justify-content-end gap-2">
                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="submit" className="btn btn-primary" disabled={updateLoading}>
                      {updateLoading ? <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> : null}
                      {updateLoading ? 'Updating...' : 'Save Changes'}
                    </button>
                  </div>
                </form>
              </div>
            </div></div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Communities;
